// extracted by mini-css-extract-plugin
export default {"wrap":"aH-z","fullWidth":"bH-z","hideOnDesktop":"cH-z","content":"dH-z","hasOpenedNav":"eH-z","crumbsList":"fH-z","dropdownsWrap":"gH-z"};